import React, { useState } from 'react';
import { DialogInput, RequiredDialogInput, handleInputChange } from '../DialogInputs';
import CommonConfigDialog from './CommonConfigDialog';
import SiteOrBusinessUnitSelect from '../SiteOrBusinessUnitSelect';
import { useSaveCategory, useDeleteCategory } from '../../../../hooks/useCategories';
import SubCategoriesTable from '../SubCategoriesTable';

function CategoryEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {
    const [fieldErrors, setFieldErrors] = useState({});
    const { saveCategory } = useSaveCategory();
    const { deleteFunction } = useDeleteCategory(dialogData);

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    };

    return (
        <CommonConfigDialog title={"Category - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveCategory} canDelete deleteFunction={deleteFunction} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} >
            <RequiredDialogInput controlId="formCategoryName" title="Name" placeholder="Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <SiteOrBusinessUnitSelect controlIdPrefix="Category" dialogData={dialogData} setDialogData={setDialogData} fieldErrors={fieldErrors} />
            <DialogInput controlId="formCategoryDisplay" title="Display" placeholder="Display" name="display" value={dialogData.display} error={fieldErrors.display} onChange={onChange} />
            <DialogInput controlId="formCategoryTranslationKey" title="Translation Key" placeholder="Translation.Key" name="translationKey" value={dialogData.translationKey} error={fieldErrors.translationKey} onChange={onChange} />
            <SubCategoriesTable data={dialogData.subCategories} categoryId={dialogData.id} setDialogData={(subCat) => setDialogData({ ...dialogData, subCategories: subCat })} /> 
        </CommonConfigDialog>
    );
}

export default CategoryEditDialog;